import { Box, Typography } from "@mui/material";
import * as turf from "@turf/turf";

// components
import { TooltipCustom } from "../../ui/tooltip-custom";
import { SiteUpload } from "../site-upload/site-upload";
import { TutorialPopupDrawing } from "../../tutorials/tutorial-popup-drawing";

// services
import { useSiteSettingsContext } from "../../../services/context/site-settings-context";
import {
  PROPERTY_SOURCE,
  UNITS,
} from "../../../constants/site-settings.constants";
import { formatArea } from "../../../utils/formatting";
import { TEXT } from "../../../constants/text";

// svg
import { ReactComponent as IconFileDXF } from "../../../assets/svg/dxf-file-icon.svg";


export const BoundariesTab = ({
  propertyData,
  propertyArea,
  perimeter,
  propertyGeoJSON,
  updatePropertyData,
}) => {
  const { uploading, setUploading, deleteDrawing } = useSiteSettingsContext();

  const polygon = propertyGeoJSON?.features[0];

  const area = polygon ? turf.area(polygon) : 0;
  const displayArea = uploading
    ? propertyData.uploadedPropertyArea
    : propertyArea && propertyArea !== -1
    ? propertyArea
    : area;
  const displayPerimeter = uploading
    ? propertyData.uploadedPropertyPerimeter
    : perimeter;

  const fileName = uploading
    ? propertyData.uploadedFileName
    : propertyData.fileName;
  const fileUnits = uploading ? propertyData.uploadedUnits : propertyData.units;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        paddingLeft: "16px",
        width: "100%",
        pt: "6px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          mb: "18px",
        }}
      >
        <Typography sx={{ fontSize: "24px" }}>
          {TEXT.siteSettings.siteAreaTitle}
        </Typography>
        {/* <TutorialPopupDrawing display={!propertyGeoJSON} /> */}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: "4px",
          mb: "24px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "8px",
          }}
        >
          <Typography sx={{ fontSize: "14px" }}>
            Draw the shape of your site using the bottom tool bar
          </Typography>
          <TutorialPopupDrawing display={!propertyGeoJSON} />
        </Box>
        <Typography
          sx={{
            fontSize: "14px",
            color: "#7b7b7e",
            textAlign: "center",
            mr: "46px",
          }}
        >
          or
        </Typography>
        <SiteUpload
          setUploading={setUploading}
          updatePropertyData={updatePropertyData}
          propertyData={propertyData}
          deleteDrawing={deleteDrawing}
        />
      </Box>

      {(uploading && propertyData.uploadedFileName) ||
      (!uploading &&
        propertyData.propertySource === PROPERTY_SOURCE.FILE &&
        propertyData.fileName) ? (
        <Box
          sx={{
            width: "100%",
            height: "auto",
            background: "#f1f1f8",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px",
            gap: "24px",
            borderRadius: "8px",
            mb: "16px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <IconFileDXF width="18px" height="18px" fill="#000" />
            <Box>
              <TooltipCustom
                text={fileName ? fileName : "Uploaded file"}
                key={"file" + "tooltip"}
              >
                <Typography
                  variant="body2"
                  sx={{
                    textOverflow: "ellipsis",
                    width: "170px",
                    overflow: "hidden",
                    textWrap: "nowrap",
                  }}
                >
                  {fileName ? fileName : "Uploaded file"}
                </Typography>
              </TooltipCustom>

              {/* <TooltipCustom
                text={
                  propertyData.units ? UNITS[propertyData.units] : "not found"
                }
                key={"file" + "tooltip"}
              > */}
              <Typography
                variant="body2"
                color="#777"
                mt="4px"
                fontSize={"12px"}
                /* sx={{
                    textOverflow: "ellipsis",
                    width: "170px",
                    overflow: "hidden",
                    textWrap: "nowrap",
                  }} */
              >
                Units: {fileUnits ? UNITS[fileUnits] : "not found"}
              </Typography>
              {/* </TooltipCustom> */}
            </Box>
          </Box>
        </Box>
      ) : null}

      <Typography
        sx={{
          fontSize: "12px",
          color: "#343745",
          m: "0 0 4px 8px",
          fontWeight: 500,
        }}
      >
        Area
      </Typography>
      <Box
        sx={{
          background: "#EBEBEC",
          borderRadius: "8px",
          border: "1px solid #DBDBEB",
          padding: "8px",
          width: "100%",
        }}
      >
        <Typography sx={{ fontSize: "14px", color: "#343745" }}>
          {displayArea
            ? `${formatArea(displayArea).value} ${formatArea(displayArea).unit}`
            : "0 m²"}
        </Typography>
      </Box>

      <Typography
        sx={{
          fontSize: "12px",
          color: "#343745",
          m: "16px 0 4px 8px",
          fontWeight: 500,
        }}
      >
        Perimeter
      </Typography>
      <Box
        sx={{
          background: "#EBEBEC",
          borderRadius: "8px",
          border: "1px solid #DBDBEB",
          padding: "12px",
          width: "100%",
        }}
      >
        <Typography sx={{ fontSize: "14px", color: "#343745" }}>
          {displayPerimeter ? displayPerimeter.toFixed(2) : 0} m
        </Typography>
        <Box />
      </Box>

      {/* <Box sx={{ display: "flex", mt: "16px" }}>
        <Box>
          <IconInformation fill="#5D5F6A" width="24px" height="24px" />
        </Box>

        <Typography sx={{ fontSize: "12px", color: "#777982", ml: "8px" }}>
          {TEXT.siteSettings.siteAreaTooltip}
        </Typography>
      </Box> */}
    </Box>
  );
};
